import Api from "shared/service/api/api";

// actions
export const LOAD_ALERTS = "loadAlerts";
export const CREATE_ALERT = "createAlert";

//mutations
export const SET_ALERTS = "setAlerts";

const state = {
  alerts: [],
};

const getters = {
  alertTypes: () => [
    { id: 1, name: "Обычное", variant: "primary" },
    { id: 2, name: "Важное", variant: "danger" },
    { id: 3, name: "Нейтральное", variant: "secondary" },
    { id: 4, name: "Предупреждение", variant: "warning" },
  ],
};

const actions = {
  [LOAD_ALERTS]({ commit }) {
    Api.alert
      .all()
      .then((response) => {
        if (!response.success) {
          throw new Error(response.error);
        }

        commit(SET_ALERTS, response.data);
      })
      .catch((e) => e);
  },
  [CREATE_ALERT]() {
    return new Promise((resolve) => {
      Api.alert
        .create()
        .then((response) => {
          if (!response.success) {
            throw new Error(response.error);
          }

          resolve(response.data.id);
        })
        .catch(() => resolve(undefined));
    });
  },
};

const mutations = {
  [SET_ALERTS](state, data) {
    state.alerts = data;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
